import { render, staticRenderFns } from "./PageHomeService.vue?vue&type=template&id=e0253a18&"
import script from "./PageHomeService.vue?vue&type=script&lang=js&"
export * from "./PageHomeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports